const getSitechromeModalUrl = ({ baseUrl, additionalParams = {} }) => {
  const params = new URLSearchParams(additionalParams).toString();

  if (params) return `${baseUrl}?${params}`;

  return baseUrl;
};

export default getSitechromeModalUrl;
